module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ab7968f239275b438d7f98891394c2ec.png";